<template>
  <div id="app">
    <auth-view v-if="authorizationStatus != 1"/>
    <loading-view v-if="authorizationStatus == 1 && !loaded"
                  :progress="(totalTokens - totalDataStatuses) / totalTokens"/>
    <div class="display-container" v-if="authorizationStatus == 1 && loaded">
      <div class="sidebar-wrapper">
        <sidebar-view :loaded-modules="loadedModules"/>
      </div>
      <div class="content-wrapper">
        <router-view/>
      </div>
    </div>


    <notifications group="application" position="top right">
      <template slot="body" slot-scope="props">
        <div :class="{ 'ot-notification-style': true, [props.item.type]: true}">
          <h1>
            {{ props.item.title }}
          </h1>
          <div style="display: flex; flex-flow: row;">
            <icon :icon="['fal', 'check']" size="3x" style="margin-right: 10px;"
                  v-if="props.item.type == 'ok'"/>
            <icon :icon="['fal', 'exclamation-triangle']" size="3x" style="margin-right: 10px;"
                  v-if="props.item.type == 'warn'"/>
            <icon :icon="['fal', 'exclamation-square']" size="3x" style="margin-right: 10px;"
                  v-if="props.item.type == 'error'"/>
            <div v-html="props.item.text">
            </div>
            <!--                    <a class="close" @click="props.close">-->
            <!--                        <i class="fa fa-fw fa-close"></i>-->
            <!--                    </a>-->

          </div>
        </div>
      </template>
    </notifications>
    <v-modal name="highlightModal" classes="transparent-modal" style="background-color: rgba(10,10,10,0.66)"
             :width="800" :height="600">
      <div style="background-color: var(--card-background-color); text-align: center; padding: 20px;">
        <h1>Drop the file for upload</h1>
      </div>
    </v-modal>
    <v-modal name="importModal" classes="transparent-modal" style="background-color: rgba(10,10,10,0.66)"
             :width="800" :height="600">
      <basic-card>
        <template slot="header">
          File upload
        </template>
        <file-upload-component
            :uploaded-files="uploadedFiles"
            :upload-callback="uploadCallback"
            @cancel="cancelUpload"
        />
      </basic-card>
    </v-modal>
    <v-modal name="processImportModal" classes="transparent-modal" style="background-color: rgba(10,10,10,0.66); padding-bottom: 40px;"
             :width="800" :height="800">
      <basic-card>
        <template slot="header">
          Zpracovat soubory
        </template>
        <data-table
            :configuration="readyFilesTableConfig"
            :data="readyFiles"
            @selectionChanged="selectFilesToProcess"
            component-id="app-readyFileTable"
        />
        <form-wrapper>
          <form-text-input caption="Název zdroje" v-model="fileSource"/>
          <form-select-input caption="Vybraný proces/skript" v-model="fileImportDefinition"
                             :options="importDefinitionOptions"/>
        </form-wrapper>
        <simple-button @press="doImport">Zpracovat vybrané</simple-button>
      </basic-card>
    </v-modal>
    <v-modal name="reconcileCashEventModal" classes="transparent-modal"
             style="background-color: rgba(10,10,10,0.66)"
             :width="1200" :height="800">
      <div style="width: 100%; height: 100%; overflow-y: scroll;">
        <reconciliation-account-balance-items-card
            :cash-event="reconciliationCashEvent"/>
      </div>
    </v-modal>
    <v-modal name="searchModal">
      <basic-card>
        <div style="display: flex; flex-flow: row; grid-gap: 1em; align-items: start; width: 100%;">
          <icon :icon="['fal', 'search']" style="font-size: 2em;"/>
          <input ref="actionSearch" class="actionSearch" type="text" v-model="selectedAction" style="width: 100%;" v-on:keyup="doExternalSearch"/>
        </div>
      </basic-card>
      <basic-card>
        <framed-content :title="$t('search.availableActions')">
          <div class="availableActionItem" v-for="action in filteredActions" @click="action.handler"
               v-html="action.name"></div>
        </framed-content>
        <framed-content :title="$t('search.searchResults')" v-if="lastSearchResults.length > 0">
          <div v-for="(result, idx) in lastSearchResults">
            {{idx}}: {{result.id}} {{result.name}} <simple-button style="display: inline-block;" @press="openSearchOperation(result)"><icon :icon="['fal', 'external-link']"/></simple-button>
          </div>
        </framed-content>

      </basic-card>
    </v-modal>
    <v-modal name="searchOperationModal" classes="transparent-modal" style="background-color: rgba(10,10,10,0.66)">
      <operation-editor-layout v-if="searchOperation != null" :key="searchOperation.id"
                               :operation="searchOperation"
                               @cancel="handleCancel"
      />
    </v-modal>
  </div>
</template>

<script>
import _ from 'lodash';
import SidebarView from "./views/SidebarView";
import LoadingView from "./views/LoadingView";
import TopBarView from "./views/TopBarView";
import BasicCard from "./components/layout/BasicCard";
import FileUploadComponent from "./components/files/FileUploadComponent";
import SimpleButton from "./components/button/SimpleButton";
import {mapGetters, mapState} from "vuex";
import DataTable from "./components/table/DataTable";
import FormWrapper from "./components/form/FormWrapper";
import FormTextInput from "./components/form/FormTextInput";
import FormSelectInput from "./components/form/FormSelectInput";
import AuthView from "./views/AuthView";
import ReconciliationAccountBalanceItemsCard from "./cards/ReconciliationAccountBalanceItemsCard";
import Vue from "vue";
import Axios from "axios";
import FramedContent from "@/components/layout/FramedContent";
import OperationEditorLayout from "@/layout/OperationEditorLayout";

export default {
  components: {
    OperationEditorLayout,
    FramedContent,
    ReconciliationAccountBalanceItemsCard,
    AuthView,
    FormSelectInput,
    FormTextInput,
    FormWrapper,
    DataTable, SimpleButton, FileUploadComponent, BasicCard, TopBarView, LoadingView, SidebarView
  },
  data: function () {
    return {
      availableActions: [
        {
          name: "Go to Home",
          handler: () => {
            this.$router.push("/");
          }
        },
        {
          name: "Go to Accounts",
          handler: () => {
            this.$router.push("/banking/accounts");
          }
        }
      ],
      lastSearchResults: [],
      selectedAction: null,
      searchOperation: null,
      loaded: false,
      modal: false,
      hoveringFiles: false,
      uploadedFiles: null,
      readyFiles: null,
      startedImport: false,
      fileImportDefinition: null,
      fileSource: 'default',
      filesToProcess: [],
      usedTheme: {},
      reconciliationCashEvent: null,
      readyFilesTableConfig: {
        enableCheck: true,
        columns: [
          {
            caption: "File name",
            datum: d => d.fileName
          }
        ]
      },
      totalTokens: 3 + 2 + 2 + 4 + 4 + 1 + 1 + 1 + 1 + 1,
      dataStatus: {
        accounts: {
          caption: "Accounts",
          loadedTokens: 3
        },
        currencies: {
          caption: "Currencies",
          loadedTokens: 2
        },
        operations: {
          caption: "Operations",
          loadedTokens: 4
        },
        parties: {
          caption: "Parties",
          loadedTokens: 3
        },
        cashflow: {
          caption: "Cashflow",
          loadedTokens: 5
        },
        payments: {
          caption: "Payment",
          loadedTokens: 1
        },
        imports: {
          caption: "Import",
          loadedTokens: 1
        },
        frontend: {
          caption: "Frontend",
          loadedTokens: 4
        },
        users: {
          caption: "Users",
          loadedTokens: 2
        }
      }
    }
  },
  methods: {
    openSearchOperation(op) {
        this.searchOperation = op;
        this.$modal.show("searchOperationModal")
    },
    handleCancel() {
      this.$modal.show("hideOperationModal")
    },
    doExternalSearch: _.debounce(async function() {
        let searchString = this.selectedAction;
        if(!searchString) {
          this.lastSearchResults = [];
        }
        else {
          let data = (await Axios.get(`search/api/v1/search?query=${searchString}`)).data;
          this.lastSearchResults = await Promise.all(data.map(async item => {
            return (await Axios.get(`operation/api/v1/operations/${item.objectId}`)).data;
          }))
        }
    }, 500),
    cancelUpload() {
      this.modal = false;
      this.uploadedFiles = null;
      this.readyFiles = null;
      this.startedImport = false;
      this.$modal.hide("importModal");
    },
    selectFilesToProcess(files) {
      this.filesToProcess = files;
    },
    uploadCallback(res) {
      this.readyFiles = res.map(file => ({selected: true, ...file}));
      this.$modal.hide("importModal");
      this.$modal.show("processImportModal")
    },
    doImport() {
      this.startedImport = true;
      this.filesToProcess.map(file => {
            Axios.post("processing/api/v1/processes", {
                  values: {
                    file: `http://opentreasury/resource/api/v1/files/${file.id}/data`,
                    source: this.fileSource
                  },
                  definitionId: this.fileImportDefinition,
                }
            ).then(res => {
              if (res.status === 204) {
                this.$notify({
                  group: 'application',
                  title: `Import started`,
                  text: `Import of file ${file.fileName} started`,
                  type: "ok"
                })
              } else if (res.status === 409) {
                this.$notify({
                  group: 'application',
                  title: 'Import failed',
                  text: `Import of file ${file.fileName} didn't start, because of other import in progress`,
                  type: "error"
                })
              }

            })
          }
      )
      this.$modal.hide("processImportModal");
    },
    loadInitialData() {
      Promise.allSettled(
          [this.$store.dispatch("banking/refreshAccounts").then(() => this.dataStatus.accounts.loadedTokens--),
            this.$store.dispatch("banking/refreshBanks").then(() => this.dataStatus.accounts.loadedTokens--),
            this.$store.dispatch("currencies/refreshCurrencies").then(() => this.dataStatus.currencies.loadedTokens--),
            this.$store.dispatch("currencies/refreshExchangeRates").then(() => this.dataStatus.currencies.loadedTokens--),
            this.$store.dispatch("operationDefinitions/refreshOperationDefinitions").then(() => this.dataStatus.operations.loadedTokens--),
            this.$store.dispatch("operationLinkDefinitions/refreshOperationLinkDefinitions").then(() => this.dataStatus.operations.loadedTokens--),
            this.$store.dispatch("operationDefinitionGroups/refreshOperationDefinitionGroups").then(() => this.dataStatus.operations.loadedTokens--),
            this.$store.dispatch("partyRoleTypes/refreshPartyRoleTypes").then(() => this.dataStatus.parties.loadedTokens--),
            this.$store.dispatch("parties/refreshParties").then(() => this.dataStatus.parties.loadedTokens--),
            this.$store.dispatch("cashflowSetups/refreshCashflowSetups").then(() => this.dataStatus.cashflow.loadedTokens--),
            this.$store.dispatch("cashEventQueries/refreshCashEventQueries").then(() => this.dataStatus.cashflow.loadedTokens--),
            this.$store.dispatch("cashflowReportDefinitions/refreshCashflowReportDefinitions").then(() => this.dataStatus.cashflow.loadedTokens--),
            this.$store.dispatch("cashflowReportColumns/refreshCashflowReportColumns").then(() => this.dataStatus.cashflow.loadedTokens--),
            this.$store.dispatch("accountOwnerships/refreshAccountOwnerships").then(() => this.dataStatus.accounts.loadedTokens--),
            this.$store.dispatch("accountOwnerships/refreshSupportedPartyRoleIds").then(() => this.dataStatus.parties.loadedTokens--),
            this.$store.dispatch("operationQueries/refreshOperationQueries").then(() => this.dataStatus.operations.loadedTokens--),
            this.$store.dispatch("paymentBatches/refreshPaymentBatches").then(() => this.dataStatus.payments.loadedTokens--),
            this.$store.dispatch("importDefinitions/refreshImportDefinitions").then(() => this.dataStatus.imports.loadedTokens--),
            this.$store.dispatch("gui/loadLanguages").then(() => this.dataStatus.frontend.loadedTokens--),
            this.$store.dispatch("dashboards/refreshDashboards").then(() => this.dataStatus.frontend.loadedTokens--),
            this.$store.dispatch("users/refreshUsers").then(() => this.dataStatus.users.loadedTokens--),
            this.$store.dispatch("securityGroups/refreshSecurityGroups").then(() => this.dataStatus.users.loadedTokens--),
            this.$store.dispatch("cashEffects/refreshCashEffects").then(() => this.dataStatus.cashflow.loadedTokens--),
            this.$store.dispatch("personalization/FETCH_ALL").then(() => this.dataStatus.frontend.loadedTokens--),
            this.$store.dispatch("userPreferences/FETCH_PREFERENCES", this.actualUser).then(() => this.dataStatus.frontend.loadedTokens--),
          ]
      )
          .then(data => {
                this.$store.dispatch("banking/refreshAllBalances")
              }, data => console.log("Promise", data)
          )
          .then(
              () => {
                this.loaded = true;
              },
              () => {
                this.loaded = false
              });
    },
    prepareFileHandlers() {
      let fileUpload = document.getElementById("app");

      ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
        fileUpload.addEventListener(eventName, preventDefaults, false)
      })

      function preventDefaults(e) {
        e.preventDefault()
        e.stopPropagation()
      }

      ['dragenter'].forEach(eventName => {
        fileUpload.addEventListener(eventName, highlight.bind(this), false)
      })

      ;['dragleave'].forEach(eventName => {
        fileUpload.addEventListener(eventName, unhighlight.bind(this), false)
      })

      function highlight(e) {
        function containsFiles(event) {

          if (event.dataTransfer.types) {
            for (var i = 0; i < event.dataTransfer.types.length; i++) {
              if (event.dataTransfer.types[i] == "Files") {
                return true;
              }
            }
          }

          return false;

        }

        if (e.relatedTarget !== null || !containsFiles(e)) return;
        this.hoveringFiles = true;
        this.modal = true;
        this.$modal.show("highlightModal");
      }

      function unhighlight(e) {
        if (e.relatedTarget !== null) return;
        this.hoveringFiles = false;
        this.modal = false;
        this.$modal.hide("highlightModal");
      }

      fileUpload.addEventListener('drop', handleDrop.bind(this), false)

      function handleDrop(e) {
        if (!this.hoveringFiles) return;
        let dt = e.dataTransfer
        let files = dt.files
        this.uploadedFiles = files;
        this.hoveringFiles = false;
        this.$modal.hide("highlightModal");
        this.$modal.show("importModal");
      }
    },
    reconcile(cashEvent) {
      this.reconciliationCashEvent = cashEvent;
      this.$modal.show("reconcileCashEventModal")
    }
  },
  mounted() {
    this.$store.dispatch("auth/RELOAD_STATE");
    this.prepareFileHandlers();
    const theme = {...this.theme};
    Object.keys(theme).forEach(key => theme[key] = theme[key].hex());
    this.usedTheme = theme;
    this.pushTheme(theme);
    this.$eventBus.$on('reconcileCashEvent', this.reconcile);
    let lastClick = new Date()
    let lastKey = "";
    window.addEventListener("keyup", ev => {
      if (ev.key == "Home" && lastKey == "Home") {
        if (this.$moment().diff(lastClick, 'ms') < 400) {
          this.selectedAction = "";
          this.$modal.show("searchModal");
          setTimeout(() => this.$refs.actionSearch.focus(), 100);

        }
      }
      lastClick = new Date();
      lastKey = ev.key;
    })
  },
  watch: {
    authorizationStatus: {
      handler(newVal, oldVal) {
        if (newVal == 1) {
          this.loadInitialData();
          const msgHandler = (msg) => {
            let resData = JSON.parse(msg.body);
            resData.forEach(notification => {
              Vue.prototype.$notify({
                group: 'application',
                title: notification.caption,
                text: notification.message,
                type: notification.category == 'ERROR' ? 'error' : 'ok'
              });
            })
          };

          Vue.prototype.stompClient.connect({
                'Authorization': `Bearer ${this.$store.getters['auth/actualPrincipal'].token}`,
                'X-Authorization': `${this.$store.getters['auth/actualPrincipal'].token}`
              },
              (frame) => {
                Vue.prototype.stompClient.subscribe('/topic', msgHandler);
              },
              (err) => {
              }
          );
        }
      }
    }
  },
  computed: {
    filteredActions() {
      let result = this.$_.cloneDeep(this.availableActions);
      result = result.filter(action => action.name.includes(this.selectedAction))
      result.forEach(action => {
        const searchText = this.selectedAction;
        const regex = new RegExp(searchText, 'gi');
        action.name = action.name.replace(/(<mark class="highlight">|<\/mark>)/gim, '');
        action.name = action.name.replace(regex, '<mark class="highlight">$&</mark>');
      })
      return result;
    },
    loadedModules() {
      return Object.keys(this.dataStatus)
          .reduce((obj, key) => {
            obj[key] = this.dataStatus[key].loadedTokens == 0;
            return obj;
          }, {});
    },
    contextPaymentBatch: {
      get() {
        return this.activePaymentBatch
      },
      set(value) {
        this.$store.commit('paymentBatches/setActivePaymentBatch', value)
      }
    },
    totalDataStatuses() {
      return Object.keys(this.dataStatus).reduce((acc, curr) => {
        acc += this.dataStatus[curr].loadedTokens;
        return acc;
      }, 0)
    },
    ...mapState('gui', {
      theme: 'theme'
    }),
    ...mapState('paymentBatches', {
      activePaymentBatch: 'activePaymentBatch',
    }),
    ...mapState('auth', {
      authorizationStatus: "authStatus"
    }),
    ...mapGetters({
      importDefinitionOptions: "importDefinitions/importDefinitionOptions",
      paymentBatches: "paymentBatches/paymentBatches",
      actualUser: "auth/actualPrincipal"
    })
  }
}
</script>

<style lang="scss">
@import "styles/global.scss";

:root {
  --background-color: #262C32;
  --accent-color: #2cc809;
  --selection-color: var(--accent-color);
  --header-font-color: var(--background-color);

  --card-font-color: var(--background-color);
  --card-background-color: var(--background-color);
  --card-light-background-color: var(--background-color);

  --table-body-color: var(--background-color);
  --table-body-font-color: var(--background-color);
  --table-header-color: var(--background-color);
  --table-header-font-color: var(--background-color);
  --table-border-color: var(--background-color);
  --table-body-font-selection-color: var(--background-color);
  --table-body-selection-color: var(--background-color);
  --table-body-highlight-color: var(--background-color);
  --table-body-font-highlight-color: var(--background-color);

  --input-border-color: var(--background-color);
  --input-background-color: var(--background-color);
  --input-font-color: var(--background-color);
  --input-selection-color: var(--background-color);
  --input-active-background-color: var(--background-color);
  --input-active-font-color: var(--background-color);
  --input-placeholder-font-color: var(--background-color);
  --input-active-border-color: var(--background-color);

  --input-list-background-color: var(--background-color);
  --input-list-selection-color: var(--accent-color);

  --input-check-off-background-color: var(--accent-color);
  --input-check-on-background-color: var(--accent-color);
  --input-check-off-color: var(--accent-color);
  --input-check-on-color: var(--accent-color);

  --button-font-color: var(--accent-color);
  --button-background-color: var(--accent-color);
  --button-background-hover-color: var(--accent-color);

  --divider-color: var(--background-color);

  --accent-color-minus-25: var(--accent-color);
  --accent-color-minus-50: var(--accent-color);
  --accent-color-minus-75: var(--accent-color);

  --accent-color-plus-25: var(--accent-color);
  --accent-color-plus-50: var(--accent-color);
  --accent-color-plus-75: var(--accent-color);
}

@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;400;600&display=swap');
@import url('https://fonts.googleapis.com/css?family=Poppins&display=swap');

#app {
  font-family: "Source Sans Pro";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  /*padding: 20px;*/
}

html {
  box-sizing: border-box;
  height: 100%;
  scroll-behavior: smooth;
}

*, *:before, *:after {
  box-sizing: inherit;
}

* {
  break-inside: avoid;
  -webkit-column-break-inside: avoid;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

}

.tooltip {
  display: block !important;
  z-index: 10000;
  font-family: "Lato Light";

  .tooltip-inner {
    background: black;
    color: white;
    border-radius: 5px;
    padding: 5px 10px 4px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
}

*::-webkit-scrollbar {
  width: 13px;
  height: 13px;
}

*::-webkit-scrollbar-track {
  background: var(--card-background-color);
}
*::-webkit-scrollbar-thumb {
  background-color: #7a7b7c;
  border-radius: 6px;
  border: 3px solid #7a7b7c;
}

body {
  background-color: var(--background-color);
  margin: 0;
  padding: 0;
  font-size: 13px;
}

h1 {
  color: var(--header-font-color);
  font-size: 14px;
  font-weight: normal;
  margin: 8px 0;
}

h2 {
  color: var(--header-font-color);
  font-size: 12px;
  font-weight: normal;
  margin: 8px 0;
}

.content-wrapper {
  position: relative;
  width: calc(100% - 50px);
  left: 50px;
}

.sidebar-wrapper {
  position: fixed;

  height: 100vh;
  width: 50px;
}

.display-container {
  height: 100%;
}

.fade-enter-active {
  animation: fade-in .5s;
}

.fade-leave-active {
  animation: fade-in .5s reverse;
}

@keyframes fade-in {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0;
  }
}

/** animations */

.slide-enter-active {
  transition-duration: 1s;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  transition-duration: 1s;
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to, .slide-leave {
  max-height: 100px;
  overflow: hidden;
}

.slide-enter, .slide-leave-to {
  overflow: hidden;
  max-height: 0;
}

::selection {
  background: var(--selection-color); /* WebKit/Blink Browsers */
}

a {
  color: var(--header-font-color);
}

$notificationBorder: 1px solid var(--input-font-color);

.v--modal-overlay {
  overflow-y: scroll;
  scrollbar-width: thin;
  //scrollbar-color: var(--thumbBG) var(--scrollbarBG);
}

.v--modal-overlay::-webkit-scrollbar {
  width: 13px;
  height: 13px;
}

.v--modal-overlay::-webkit-scrollbar-track {
  background: var(--card-background-color);
}

.v--modal-overlay::-webkit-scrollbar-thumb {
  background-color: #7a7b7c;
  border-radius: 6px;
  border: 3px solid #7a7b7c;
}

.v--modal-box {
  background: rgba(226, 55, 40, 0) !important;
  height: fit-content !important;
  width: 60vw !important;
  left: 20vw !important;
  top: 50px !important;
}

.ot-notification-style {
  padding: 0px 5px 5px 5px;
  margin: 15px 15px 5px;

  font-size: 12px;

  color: #ffffff;
  background: var(--card-background-color);
  border-left: 4px solid #187FE7;
  border-bottom: $notificationBorder;
  border-top: $notificationBorder;
  border-right: $notificationBorder;


  &.error {
    border-left-color: var(--accent-color);
  }

  &.ok {
    border-left-color: var(--input-check-on-color);
  }

  &.neutral {
    border-left-color: var(--card-background-color);
  }
}

.highlight {
  background-color: transparentize($openRed, 0.5);
  color: white;
}

.actionSearch {
  background-color: transparent;
  border: 0;
  font-size: 2em;
  color: var(--card-font-color);
  border-bottom: 1px solid var(--card-font-color);
}


</style>
